/** @format **/

import { generateScreen } from "./generator";

const extendedConditions = require("../../../subflows/conditions");

const transitionScreens = (i18n) => ({
  transition: {
    type: "chapter-description.transition",
    params: {
      jumbotronPicture: require("static/Mobile-Transition.jpg"),
      jumbotronPictureDesktop: require("static/Desktop-Transition.jpg"),
      header: (store) => i18n.t("specifics:transition.header"),
      hideTitle: true,
      description: (store) => i18n.t("specifics:transition.description"),
      buttonText: (store) => i18n.t("specifics:transition.button"),
      showKeyboardOnNextScreen: true,
    },
  },

  transitionPlaySafe: {
    type: "chapter-description.transition-play-safe",
    params: {
      jumbotronPicture: require("static/Mobile-Transition.jpg"),
      jumbotronPictureDesktop: require("static/Desktop-Transition.jpg"),
      header: (store) => i18n.t("specifics:transition-play-safe.header"),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-play-safe.description"),
      buttonText: (store) => i18n.t("specifics:transition-play-safe.button"),
    },
  },

  transitionVerifyIdent: {
    type: "chapter-description.transition-verify-identity",
    params: {
      jumbotronPicture: require("static/verification-bg.jpg"),
      jumbotronPictureDesktop: require("static/verification-desktop.jpg"),
      header: (store) => i18n.t("specifics:transition-verify-identity.header"),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-verify-identity.description"),
      buttonText: (store) =>
        i18n.t("specifics:transition-verify-identity.button"),
    },
  },

  transitionVerifyIntro: {
    type: "chapter-description.transition-verify-intro",
    params: {
      jumbotronPicture: require("static/verify/transition-intro-mobile.jpg"),
      jumbotronPictureDesktop: require("static/verify/transition-intro-desktop.jpg"),
      header: (store) => i18n.t("specifics:transition-verify-intro.header"),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-verify-intro.description"),
      buttonText: (store) => i18n.t("specifics:transition-verify-intro.button"),
      margined: true,
      large: true,
      showCloseButton: true,
    },
  },

  transitionSuccess: {
    type: "chapter-description.transition-success",
    params: {
      jumbotronPicture: require("static/success-bg.jpg"),
      jumbotronPictureDesktop: require("static/success-desktop.jpg"),
      header: (store) => i18n.t("specifics:transition-success.header"),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-success.description"),
      buttonText: (store) => i18n.t("specifics:transition-success.button"),
      conditions: [...extendedConditions.showSuccessVerificationScreen],
    },
  },

  transitionDocumentScan: {
    type: "chapter-description.transition-document-scan",
    params: {
      jumbotronPicture: require("static/scan-mobile.jpeg"),
      jumbotronPictureDesktop: require("static/scan-desktop.jpeg"),
      header: (store) => i18n.t("specifics:transition-document-scan.header"),
      subheader: () => i18n.t("specifics:transition-document-scan.subheader"),
      subheaderIcon: require("static/thumb.svg"),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-document-scan.description"),
      buttonText: (store) =>
        i18n.t("specifics:transition-document-scan.button"),
      primaryAction: (store) => {
        store.commit("ocrSetIsOcrMethodSelected", true);
      },
      secondaryOption: {
        text: () =>
          i18n.t("specifics:transition-document-scan.secondary-option"),
        action: (store) => {
          store.commit("ocrSetIsOcrMethodSelected", false);
        },
      },
      showKeyboardOnNextScreen: true,
    },
  },

  transitionJob: {
    type: "chapter-description.transition-job",
    params: {
      jumbotronPicture: require("static/job-mobile.jpeg"),
      jumbotronPictureDesktop: require("static/job-desktop.jpeg"),
      header: (store) =>
        i18n.t("specifics:transition-job.header", {
          firstName: store.state.user.firstName,
        }),
      hideTitle: true,
      description: (store) => i18n.t("specifics:transition-job.description"),
      buttonText: (store) => i18n.t("specifics:transition-job.button"),
      showKeyboardOnNextScreen: true,
    },
  },

  transitionLimits: {
    type: "chapter-description.transition-limits",
    params: {
      jumbotronPicture: require("static/limits-mobile.jpeg"),
      jumbotronPictureDesktop: require("static/limits-desktop.jpeg"),
      header: (store) => i18n.t("specifics:transition-limits.header"),
      hideTitle: true,
      description: (store) => i18n.t("specifics:transition-limits.description"),
      buttonText: (store) => i18n.t("specifics:transition-limits.button"),
      showKeyboardOnNextScreen: true,
      primaryButtonTrackingLabel: "transitionLimits-submit-button",
    },
  },

  transitionOcrDeclined: {
    type: "chapter-description-popup.document-scan",
    params: {
      header: (store) => i18n.t("error:ocrDeclined.header"),
      hideTitle: true,
      description: (store) => i18n.t("error:ocrDeclined.description"),
      buttonText: (store) => i18n.t("error:ocrDeclined.buttonText"),
      conditions: [
        {
          property: "ocr.ocrAttempts",
          more_than: 0,
          value: true,
        },
      ],
    },
  },
  transitionVerifyGreat: {
    type: "chapter-description.transition-verify-great",
    params: {
      jumbotronPicture: require("static/verify/success-mobile.jpg"),
      jumbotronPictureDesktop: require("static/verify/success-desktop.jpg"),
      header: ({ state }) =>
        i18n.t("specifics:transition-verify-great.header", {
          firstName: state.user.firstName,
        }),
      hideTitle: true,
      description: (store) =>
        i18n.t("specifics:transition-verify-great.description"),
      buttonText: (store) => i18n.t("specifics:transition-verify-great.button"),
    },
  },
});

export const getTransitionScreens = generateScreen.bind(
  null,
  transitionScreens
);



// WEBPACK FOOTER //
// ./src/partners/config/screens/transition.js